import React, { useState } from "react";
import { all_routes } from '../router/all_routes';
import * as api from "../common/manipurCommon/API";
import Utils from "../common/manipurCommon/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Profile = () => {

    const routes = all_routes;
    const navigate = useNavigate();
    const [oldPwd, setOldPwd] = useState('');
    const [newPwd, setNewPwd] = useState('');
    const [cnfmNwPwd, setCnfmNwPwd] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [pwdError, setPwdError] = useState('');

    const UsrName = localStorage.getItem('UserName');

    function changePwd() {
        if (!pwdError) {

            const formData = new FormData();
            formData.append('oldPassword', oldPwd)
            formData.append('newPassword', newPwd)

            const changePassWord = api.ManipurChangePassword;
            fetch(changePassWord, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                // window.location.reload(); // 🔁 Reload only after OK is clicked
                                navigate(routes.manipurlogin)
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        setPwdError(result.message)
                    }
                })
        }
    }

    function setFields() {
        setOpenModal(true)
        setOldPwd('');
        setNewPwd('');
        setCnfmNwPwd('')
        setPwdError('');
    }

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setPwdError("Passwords do not match!");
        } else {
            setPwdError("");
        }
    };
    return (
        <>
            <div className="content container" style={{ maxWidth: "1380px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items">
                                <div className="col-lg-6">
                                    <h4 className="mb-40">Profile</h4>
                                </div>
                                <div className="col-lg-6 text-end">
                                    <Button
                                        className="btn-secondary me-3 text-uppercase"
                                        variant="success"
                                        onClick={() => setFields()}
                                    >
                                        <i className="fas fa-key" />&nbsp;
                                        Change Password
                                    </Button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="col-lg-6">
                                                            <table className="col-lg-12">
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <td><h6>{UsrName}</h6></td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Role</th>
                                                                    {/* <td><h6>{details.roleName}</h6></td> */}
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered
                onHide={() => setOpenModal(false)}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="text-uppercase text-center"><i className="fas fa-key" />Change Password</h4>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Current Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="crntPwd"
                            value={oldPwd}
                            onChange={(e) => setOldPwd(e.target.value)}
                            placeholder="Current Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="newPwd"
                            value={newPwd}
                            onChange={(e) => setNewPwd(e.target.value)}
                            placeholder="New Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="cnfmPwd"
                            value={cnfmNwPwd}
                            onChange={(e) => { setCnfmNwPwd(e.target.value); validatePasswords(newPwd, e.target.value) }}
                            placeholder="Confirm Password"
                        />
                    </div>

                    {pwdError && <div className="alert alert-danger">{pwdError}</div>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={changePwd}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" /> Save</b>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default Profile;